import React from 'react';
import { TypedMemo } from '../../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the settings sections; each part uses its own slice of it */
import styles from './PlatformSettings.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SettingsAccountRowProps {
  /** The line above the name: "Posting to". */
  eyebrow: string;
  name: string;
  /** `@username`, or null. */
  handle: string | null;
  avatarUrl: string | null;
  /** The note on the right ("From TikTok, just now"). */
  note?: string;
}

function initialsOf(name: string): string {
  return name
    .split(/\s+/)
    .filter((part) => part !== '')
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');
}

/**
 * The account that gets the post: the avatar, the name and the handle the platform gave
 * (TikTok Direct Post G1; YouTube, Instagram, Facebook Page and Threads each show it too).
 */
const SettingsAccountRowComponent: React.FC<SettingsAccountRowProps> = ({ eyebrow, name, handle, avatarUrl, note }) => (
  <div className={styles.account} data-testid="settings-account">
    {avatarUrl === null ? (
      <span className={styles.avatar} aria-hidden="true">
        {initialsOf(name)}
      </span>
    ) : (
      <img className={styles.avatar} src={avatarUrl} alt="" referrerPolicy="no-referrer" />
    )}
    <div className={styles.accountText}>
      <span className={styles.eyebrow}>{eyebrow}</span>
      <span className={styles.name}>{name}</span>
      {handle === null ? null : <span className={styles.handle}>{handle}</span>}
    </div>
    {note === undefined ? null : <span className={styles.when}>{note}</span>}
  </div>
);

export const SettingsAccountRow = TypedMemo(SettingsAccountRowComponent);
